// JPEG vehicle photos are resized before base64 encoding; other formats stay intact.
export const prepareAuctionPhoto = async (file) => {
  if (
    !(file instanceof Blob) ||
    file.type !== 'image/jpeg' ||
    file.size < 300 * 1024 ||
    typeof createImageBitmap !== 'function'
  )
    return file;
  let bitmap;
  try {
    bitmap = await createImageBitmap(file);
    const scale = Math.min(1, 2048 / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(bitmap.width * scale));
    canvas.height = Math.max(1, Math.round(bitmap.height * scale));
    canvas
      .getContext('2d')
      .drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    const compressed = await new Promise((resolve) =>
      canvas.toBlob(resolve, 'image/jpeg', 0.85),
    );
    return compressed && compressed.size < file.size ? compressed : file;
  } catch {
    return file;
  } finally {
    bitmap?.close();
  }
};
